import {IncentiveListContainer} from "../../../containers/payroll/incentive/IncentiveListContainer";

export const Incentive = (props) => {
    const {list, selectedTab, onChangeTab} = props
    return (
        <div className={"h-full flex flex-col px-4 py-6 space-y-2 border-r"}>
            {
                list.map((tab, index) => (
                    <div key={index}
                         onClick={() => onChangeTab(tab)}
                         className={`w-48 px-4 py-2 flex flex-col justify-center cursor-pointer border-l-2 hover:bg-neutral-10 transition duration-200 ${selectedTab.key === tab.key ? 'font-semibold bg-primary-10 text-primary-50 border-primary-50 rounded-r' : 'font-medium text-neutral-70 border-transparent'}`}>{tab.label}</div>
                ))
            }
        </div>
    )
}
